import { ListViewChildProps } from '@app/core/list-view/ListView';
import { auditReports } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { aodRoutes } from '../../routing/routes';
import { createScheduledRunsColumns } from './ScheduledRunsColumns';

export type AodRunsScheduledListProps = ListViewChildProps<auditReports.ScheduledAodRunDto>;

/**
 * Table component for AOD Runs Scheduled V2.
 * Displays scheduled runs with filters in the ListView filter bar. Shows NullState when empty.
 */
export function AodRunsScheduledList(props: AodRunsScheduledListProps) {
  const { formatMessage } = useIntl();
  const { data, total, isLoading = false, isFetching = false, showProgress = true } = props;

  return (
    <Box>
      <MrtTable<auditReports.ScheduledAodRunDto>
        data={data}
        rowCount={total}
        state={{
          isLoading,
          showProgressBars: showProgress && (isLoading || isFetching),
        }}
        enableColumnFilters={false}
        getRowId={(row) => row.jobId}
        navigateToOnClick={(id, row) => aodRoutes.ruleView.gen(row.data.ruleId)}
        columns={createScheduledRunsColumns(formatMessage, {
          includeName: true,
          includeActions: false,
          includeRuleLink: true,
        })}
        paginationDisplayMode="default"
        enableToolbarInternalActions={false}
        // TODO: refactor
        muiTopToolbarProps={{
          sx: {
            height: '4px !important',
            minHeight: '4px !important',
          },
        }}
      />
    </Box>
  );
}
